import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';
import {Unsubscribable} from '@core/interfaces/unsubscribable';
import {Observable} from 'rxjs';

/**
 * Change password component
 * - Requires auth (must be logged in)
 * - User enters current, new, confirm password to reset password for their own account.
 * - Optional expanded (default; e.g. during login process) or collapsed (e.g. user profile) format.
 */
@Component({
    selector: 'ngx-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
    @Input() form: FormGroup;
    @Input() passwordHistory: boolean;
    @Input() validation$: Observable<any>;
    @Input() layoutCompressed: boolean = false;
    @Output() onInputChanges = new EventEmitter();

    constructor() {}

    ngOnInit(): void {
        this.form.addValidators(this.mustMatch('newPassword', 'confirmPassword'));
    }

    get currentPassword(): FormControl {
        return this.form.get('currentPassword') as FormControl;
    }

    get newPassword(): FormControl {
        return this.form.get('newPassword') as FormControl;
    }

    get confirmPassword(): FormControl {
        return this.form.get('confirmPassword') as FormControl;
    }

    onPasswordChanged($event) {
        this.onInputChanges.emit({password: $event.target.value});
    }

    private mustMatch(controlName: string, matchingControlName: string): ValidatorFn {
        return (formGroup: FormGroup): ValidationErrors => {
            const matchingControl = formGroup.controls[matchingControlName];
            const currentControl = formGroup.controls[controlName];
            if (matchingControl.errors && !matchingControl.errors.mustMatch) {
                return;
            }
            if (currentControl.value !== matchingControl.value) {
                matchingControl.setErrors({mustMatch: true});
            } else {
                matchingControl.setErrors(null);
            }
        };
    }
}
